import React from 'react';
import { XIcon, RssIcon, DownloadIcon } from 'lucide-react';
import { Story } from '../data/mockData';
interface RepublishOptionsModalProps {
  story: Story;
  onClose: () => void;
  onSelectApi: () => void;
  onSelectDownload: () => void;
}
export function RepublishOptionsModal({
  story,
  onClose,
  onSelectApi,
  onSelectDownload
}: RepublishOptionsModalProps) {
  return <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm" data-id="element-133">
      <div className="bg-white rounded-2xl max-w-2xl w-full shadow-card-lg" data-id="element-134">
        {/* Header */}
        <div className="border-b border-neutral-200 px-8 py-6 flex justify-between items-center" data-id="element-135">
          <h2 className="text-2xl font-bold text-display text-neutral-900" data-id="element-136">
            How would you like to republish?
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-neutral-100 rounded-lg transition-colors" data-id="element-137">
            <XIcon className="w-6 h-6 text-neutral-600" data-id="element-138" />
          </button>
        </div>
        {/* Content */}
        <div className="px-8 py-8" data-id="element-139">
          <p className="text-neutral-600 mb-6" data-id="element-140">
            Choose how you would like to republish "{story.title}"
          </p>
          <div className="space-y-4" data-id="element-141">
            {/* API/RSS Option */}
            <button onClick={onSelectApi} className="w-full p-6 border-2 rounded-xl hover:shadow-md transition-all text-left group" style={{
            borderColor: '#0289BB',
            backgroundColor: 'white'
          }} onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(2, 137, 187, 0.05)'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'white'} data-id="element-142">
              <div className="flex items-start gap-4" data-id="element-143">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
              }} data-id="element-144">
                  <RssIcon className="w-6 h-6 text-white" data-id="element-145" />
                </div>
                <div className="flex-1" data-id="element-146">
                  <h3 className="text-lg font-bold text-display text-neutral-900 mb-2" data-id="element-147">
                    Republish through API or RSS
                  </h3>
                  <p className="text-sm text-neutral-600" data-id="element-148">
                    Automatically publish this story to your site through our
                    API or RSS feed integration
                  </p>
                </div>
              </div>
            </button>
            {/* Download Option */}
            <button onClick={onSelectDownload} className="w-full p-6 border-2 rounded-xl hover:shadow-md transition-all text-left group" style={{
            borderColor: '#0289BB',
            backgroundColor: 'white'
          }} onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(2, 137, 187, 0.05)'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'white'} data-id="element-149">
              <div className="flex items-start gap-4" data-id="element-150">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
              }} data-id="element-151">
                  <DownloadIcon className="w-6 h-6 text-white" data-id="element-152" />
                </div>
                <div className="flex-1" data-id="element-153">
                  <h3 className="text-lg font-bold text-display text-neutral-900 mb-2" data-id="element-154">
                    Download contents of the article
                  </h3>
                  <p className="text-sm text-neutral-600" data-id="element-155">
                    Copy the title, body, and image to manually add to your CMS
                  </p>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>;
}